//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../Annotations/Annotations.LeaderBuilder.js";
import "../Annotations/Annotations.OriginBuilder.js";
import "../Annotations/Annotations.StyleBuilder.js";
import "../no/Expression.js";
let d=[[[0,"AreaSize",1,0],[0,"DatumTargetStandard",1,0],[0,"DrawX",1,1],[1,"Height",0,"Expression",0],[0,"Index",1,0],[1,"InnerDiameter",0,"Expression",0],[0,"Label",1,0],[1,"Leader",0,"Annotations.LeaderBuilder",0],[0,"Movable",1,0],[1,"MovableModifierAngle",0,"Expression",0],[1,"Origin",0,"Annotations.OriginBuilder",0],[1,"OuterDiameter",0,"Expression",0],[1,"Style",0,"Annotations.StyleBuilder",0],[0,"TerminatorType",1,0],[0,"Type",1,0],[1,"Width",0,"Expression",0]],[[["inheritTag"],"InheritFrom",{},1,0],[[],"ReverseMovableModifier",{},0,0]],[]];
SPLM.Annotations.DatumTargetBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.DatumTargetBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.DatumTargetBuilder.Types = Object.freeze({
    "Point" : "Point", "Line" : "Line", "Rectangular" : "Rectangular", "Circular" : "Circular", "Annular" : "Annular", "Spherical" : "Spherical", "Cylindrical" : "Cylindrical", "Arbitrary" : "Arbitrary"});

SPLM.Annotations.DatumTargetBuilder.TerminatorTypes = Object.freeze({
    "Arrow" : "Arrow", "X" : "X", "Plus" : "Plus"});

SPLM.Annotations.DatumTargetBuilder.StandardTypes = Object.freeze({
    "NoStandard" : "NoStandard", "AsmeY145m1982" : "AsmeY145m1982", "AsmeY145m1994" : "AsmeY145m1994", "AsmeIso11011983" : "AsmeIso11011983", "GmAddendum94" : "GmAddendum94", "Asig2000" : "Asig2000", "AsmeY1452009" : "AsmeY1452009"});

export default SPLM;